import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment';
import { dateFormats } from '../../constants/dateFormats';

@Component({
    selector: 'shared-table-date-filter',
    templateUrl: './table-date-filter.component.html',
    styleUrls: ['./table-date-filter.component.css'],
    standalone: false
})
export class TableDateFilterComponent {
  @Input() start_at = '';
  @Output() start_atChange = new EventEmitter();

  @Input() end_at = '';
  @Output() end_atChange = new EventEmitter();

  @Output() rangeChange = new EventEmitter();
  protected readonly moment = moment;
  protected readonly dateFormats = dateFormats;

  handleCustomRange() {
    this.start_atChange.emit(this.start_at);
    this.end_atChange.emit(this.end_at);

    this.rangeChange.emit();
  }
}
